module.exports = __webpack_public_path__ + "static/media/example-1.4f0efc20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyCentral/example-1.jpg
// module id = 282
// module chunks = 0